






import {Component, Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import {Editor} from '@tiptap/vue-2';
import TooltipIconButton from '@/components/button/TooltipIconButton.vue';

@Component({
  components: {TooltipIconButton},
  mixins: [InputMixin]
})
export default class EditorTextRightAlign extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: null}) private editor: Editor;

  private readonly TEXT_ALIGN_RIGHT_NAME: string = 'right';

  get getActiveClass() {
    return { 'is-active': this.editor.isActive(this.TEXT_ALIGN_RIGHT_NAME) };
  }

  private handleClick() {
    this.editor.chain().focus().setTextAlign(this.TEXT_ALIGN_RIGHT_NAME).run();
  }
}
